
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_28we7_26",
  "button": "awsui_button_vjswe_28we7_30",
  "variant-normal": "awsui_variant-normal_vjswe_28we7_82",
  "disabled": "awsui_disabled_vjswe_28we7_100",
  "variant-primary": "awsui_variant-primary_vjswe_28we7_107",
  "variant-link": "awsui_variant-link_vjswe_28we7_132",
  "variant-icon": "awsui_variant-icon_vjswe_28we7_157",
  "variant-control-group-action": "awsui_variant-control-group-action_vjswe_28we7_182",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_28we7_209",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_28we7_234",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_28we7_259",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_28we7_288",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_28we7_313",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_28we7_338",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_28we7_368",
  "button-no-text": "awsui_button-no-text_vjswe_28we7_481",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_28we7_485",
  "full-width": "awsui_full-width_vjswe_28we7_488",
  "button-compact": "awsui_button-compact_vjswe_28we7_505",
  "icon-left": "awsui_icon-left_vjswe_28we7_538",
  "icon-right": "awsui_icon-right_vjswe_28we7_543",
  "icon": "awsui_icon_vjswe_28we7_538",
  "link": "awsui_link_vjswe_28we7_562",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_28we7_562"
};
  